var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"study-pscToken"},[_c('token-box-1'),_c('token-box-2')],1)}
var staticRenderFns = []

export { render, staticRenderFns }